// extracted by mini-css-extract-plugin
export default {"GenerateInvoicePage":"GenerateInvoicePage_GenerateInvoicePage__Onym9"};